<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
// import i18n from '@/plugins/i18n';
export default {
  name: 'App',
  components: {
  },
  // data: function(){
  //   const lang =localStorage.getItem('lang') || 'en';
  //   return{
  //      lang: lang
  //   }
  // },
  methods:{
    // handleChange(event){
    //   localStorage.setItem('lang', event.target.value);
    //   window.location.reload();
    // }
  }
}
</script>

<style scoped>
#app {
  font-family:  'Noto Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html {
  scroll-behavior: smooth;
}
nav a {
  padding: 10px;
  text-decoration: none;
  border-radius: 3px;
  color: #8edbea;
  font-weight: bold;
  margin-right: 15px;
}
.exit {
    cursor: pointer;
}
</style>
